import { useEffect, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  NativeSelect,
  OutlinedInput,
} from "@mui/material";

export default function FormikSelectField({
  id,
  label,
  handleChange,
  handleBlur,
  value,
  error,
  options,
  fullWidth,
  helperText,
  sx,
  touched,
  inputSx,
  size,
  ...otherProps
}) {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (touched === undefined) {
      setIsTouched(true);
    } else {
      setIsTouched(!!touched);
    }
  }, [touched]);

  const shouldShrink = !!value;

  return (
    <FormControl
      error={isTouched && !!error}
      fullWidth={fullWidth}
      sx={{ ...sx }}
      size={size != null ? `${size}` : null}
    >
      <InputLabel htmlFor={id} shrink={shouldShrink}>
        {label}
      </InputLabel>
      <NativeSelect
        label={label}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={label} notched={shouldShrink} />}
        onBlur={handleBlur}
        id={id}
        sx={{ ...inputSx }}
        {...otherProps}
      >
        <option value="" disabled hidden style={{ display: "none" }} />
        {options &&
          options.map((option) => (
            <option key={id + "-" + option.key} value={option.key}>
              {option.label}
            </option>
          ))}
      </NativeSelect>
      {(helperText || (isTouched && error)) && (
        <FormHelperText>{error ? error : helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
